module.exports = __webpack_public_path__ + "static/media/2-draw.fc98da73.jpg";